import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { Table, Switch, LoadingOverlay } from '@mantine/core'
import { Button, Pagination, Toast } from '@ow/comps'

/**
 * 点位绑定规则列表
 */
const RuleTable = function ({
  loadData,
  switcher,
  onCreate,
  onModify,
  visible,
}) {
  const [listData, setListData] = useState([])
  const [pageInfo, setPageInfo] = useState({
    total: 0,
    size: 10,
  })
  const [loading, setLoading] = useState(true)

  const fetchData = (page, size) => {
    setLoading(true)
    loadData(page, size)
      .then((res) => {
        console.log('areas--list', res)
        setListData(res.content)
        setPageInfo({
          total: res.totalElements,
          size: res.size,
        })
        setLoading(false)
      })
      .catch(() => {
        Toast.error({
          title: '获取用户绑定信息失败',
        })
        setLoading(false)
      })
  }

  useEffect(() => {
    if (visible) {
      fetchData(0, 10)
    }
  }, [visible])

  const changeSize = (size) => {
    fetchData(0, size)
  }

  const changePage = (page) => {
    fetchData(page - 1, pageInfo.size)
  }

  const onOff = (ruleId, enable) => {
    switcher(ruleId, enable)
      .then(() => {
        Toast.success({
          title: '修改成功',
        })
      })
      .catch((err) => {
        Toast.error({
          title: err.message || '修改失败',
        })
      })
  }

  return (
    <div className="h-full">
      <div className="absolute" style={{ right: '20px', top: '20px' }}>
        <div className="flex">
          <Button type="primary" onClick={onCreate}>
            新建
          </Button>
        </div>
      </div>
      <div className="flex flex-col gap-4 h-full justify-between">
        <LoadingOverlay visible={loading} />
        <Table verticalSpacing="xs">
          <thead>
            <tr className="bg-primary-50">
              <th>编号</th>
              <th>规则名称</th>
              <th>创建时间</th>
              <th>更新时间</th>
              <th>是否启用</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {listData.map((list) => (
              <tr key={list.id}>
                <td>{list.id}</td>
                <td>{list.ruleName}</td>
                <td>{dayjs(list.createdTime).format('YYYY-MM-DD HH:mm:ss')}</td>
                <td>{dayjs(list.updatedTime).format('YYYY-MM-DD HH:mm:ss')}</td>
                <td>
                  <Switch
                    className="flex items-center cursor-pointer"
                    size="sm"
                    defaultChecked={list.enable}
                    onChange={(e) => {
                      onOff(list.id, e.target.checked)
                    }}
                  />
                </td>
                <td className="text-primary-700">
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      onModify(list)
                    }}
                  >
                    编辑
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="flex justify-end">
          <Pagination
            defaultPage={1}
            pageSize={pageInfo.size}
            total={pageInfo.total}
            pageSizeOptions={[5, 10, 20, 50]}
            showPageSize
            showJumpPage={false}
            onPageNumChange={(currentPage) => {
              changePage(currentPage)
            }}
            onPageSizeChange={(pageSize) => {
              changeSize(pageSize)
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default RuleTable
